import { getKeyStoreDataversion } from "@asosteam/asos-web-store-presentation-node";

import { getKeyStoreDataversion as getKeyStoreDataversionFromState } from "../../template/state/modules/regionalStore";

import { getKeyStoreDataversion as getKeyStoreDataversionFromManifest } from "@src/helpers/manifest";

export const getAllKeyStoreDataversions = (state, manifest) => {
  return {
    inRollback: !manifest.useCurrentKeyStoreDataversion,
    templateValue: getKeyStoreDataversionFromState(state),
    cookieValue: getKeyStoreDataversion(),
    manifestValue: getKeyStoreDataversionFromManifest(manifest)
  };
};
